/* eslint-disable */
export default {
  logging: '記錄中...',
  logCall: '記錄通話',
  editLog: '編輯記錄',
  select: '選取記錄',
  OnHold: '保留',
  Ringing: '響鈴',
  CallConnected: '通話已連線',
  unknownUser: '未知的使用者',
  unknownNumber: '匿名',
  unavailable: '無法接聽通話',
  viewDetails: '檢視詳細資訊',
  conferenceCall: '電話會議',
  callerId: '來電者 ID',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
